<template>
    <div v-if="loaded">
        <div v-cloak class="caseStudiesWrap">
            <div class="caseStudiesCategoriesWrap">
              <div class="caseStudiesCategories">
                <a
                  v-for="(name, key) in categories"
                  :key="key"
                  class="caseStudiesCategory"
                  :class="{ active: selected_category == key }"
                  :href="`/technology-solutions/${key.replace(/_/g, '-')}`"
                  :style="{ color: '#fff' }"
                  v-if="categoryCounts[key] === undefined || categoryCounts[key] > 0"
                >
                  <span>{{ name }}</span>
                </a>
              </div>
            </div>

            <div class="caseStudiesMobile">
                <div class="selectWrap">
                    <select @change="changeCategory(selected_category)" v-model="selected_category">
                        <option v-for="(category, key) in categories" :value="key" v-if="showCategory(key)">{{category}}</option>
                    </select>
                </div>
            </div>
            <div class="caseStudiesBody swiperLight">
                <div v-if="loading" class="loader">
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
                <div class="slideGrid" v-else-if="products.length > 0">
                    <a class="gridItem" v-for="product in products" :href="product.url">
                        <div class="itemImage" :style='{ backgroundImage: "url(" + getImage(product) + ")" }'></div>
                        <div class="itemMain">
                            <div class="itemMainInner">
                                <h3>{{product.data.post_title}}</h3>
                                <p>More</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="noCaseStudies" v-else>
                    No products found
                </div>
            </div>

        </div>
    </div>
    <div v-else class="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</template>
<style>
.caseStudiesCategories .caseStudiesCategory {
  color: #fff;
}
.caseStudiesCategories .caseStudiesCategory.active span:before {
    content: "";
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #F2A900;
}
</style>

<script>
export default {
    props: [
        'categories',
        'types',
        'default_type',
        'default_category'
    ],
    data() {
        return {
            loaded: false,
            loading: false,
            products: [],
            selected_type: Object.keys(this.types)[0],
            selected_category: null,
            categoryCounts: {}
        };
    },
    mounted() {
        // Detect category from URL
        const path = window.location.pathname;
        const match = path.match(/\/technology-solutions\/([^/]+)/);

        if (match && match[1]) {
            const slug = match[1];
            const categoryKey = slug.replace(/-/g, '_');
            if (this.categories[categoryKey]) {
                this.selected_category = categoryKey;
            }
        }

        this.boot();
        this.checkAllCategories();
        this.update();
    },
    methods: {
        boot() {
            if (this.default_type != null) {
                this.selected_type = this.default_type;
            }

            if (this.selected_category == null && this.default_category != null) {
                this.selected_category = this.default_category;
            }

            if (this.selected_category == null) {
                this.selected_category = 'all';
            }
        },
        checkAllCategories() {
            const vue_instance = this;
            Object.keys(this.categories).forEach((key) => {
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        'action': 'load_products',
                        'type': vue_instance.selected_type,
                        'category': key
                    },
                    success: function(data) {
                        const response = jQuery.parseJSON(data);
                        vue_instance.$set(vue_instance.categoryCounts, key, response.products.length);
                    }
                });
            });
        },
        getImage(product) {
            if (product.fields.images) {
                for (let i = 0; i < product.fields.images.length; i++) {
                    let image = product.fields.images[i];

                    if (image.category.includes(this.selected_category)) {
                        return image.category_image.sizes["grid-image"];
                    }
                }
            }

            return product.fields.grid_image.sizes["grid-image"];
        },
        showCategory(key) {
            return (this.selected_type === 'product') || (this.selected_type === 'service')
        },
        changeType(key) {
            this.selected_type = key;
            this.update();
        },
        changeCategory(key) {
            this.selected_category = key;

            const hyphenated = key.replace(/_/g, '-');
            const newUrl = `/technology-solutions/${hyphenated}`;
            window.history.pushState({ category: key }, '', newUrl);

            this.update();
        },
        update() {
            var vue_instance = this;
            this.loading = true;

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    'action': 'load_products',
                    'type': this.selected_type,
                    'category': this.selected_category
                },
                success: function(data) {
                    var response = jQuery.parseJSON(data);
                    let products = response.products;

                    products.forEach((product) => {
                        let title = product.data.post_title;
                        title = title.replace("&amp;", "&");
                        product.data.post_title = title;
                    });

                    vue_instance.products = products;
                    vue_instance.loaded = true;
                    vue_instance.loading = false;
                },
                error: function(errorThrown) {
                    console.log(errorThrown);
                }
            });
        }
    }
}
</script>